(function () {
  var EPOCH = Date.UTC(2026, 7, 29, 17, 0, 0);
  var WEEK = 7 * 24 * 60 * 60 * 1000;
  var EXTRA_KEY = "swx-ads-views-extra";
  var SEEDS = {
    "holiday-23": { base: 2200000, perWeek: 11800 },
    "fall-24-feat-the-warning": { base: 2041000, perWeek: 9400 },
    "summer-24": { base: 612400, perWeek: 3200 },
    "holiday-25": { base: 428600, perWeek: 5100 },
    "history": { base: 241300, perWeek: 1600 },
    "summer-23": { base: 188900, perWeek: 1200 },
    "behind-the-noise": { base: 96400, perWeek: 780 }
  };

  var userArmed = false;

  function normalize(handle) {
    return String(handle || "").split("/").pop();
  }

  function seedFor(handle) {
    handle = normalize(handle);
    if (SEEDS[handle]) return SEEDS[handle];
    var h = 0;
    for (var i = 0; i < handle.length; i++) h = (h * 31 + handle.charCodeAt(i)) >>> 0;
    return { base: 38000 + (h % 42000), perWeek: 600 + (h % 400) };
  }

  function extras() {
    try {
      return JSON.parse(localStorage.getItem(EXTRA_KEY) || "{}") || {};
    } catch (e) {
      return {};
    }
  }

  function extraFor(handle) {
    return extras()[normalize(handle)] || 0;
  }

  function rawCount(handle) {
    var cfg = seedFor(handle);
    var weeks = Math.max(0, (Date.now() - EPOCH) / WEEK);
    return Math.floor(cfg.base + weeks * cfg.perWeek) + extraFor(handle);
  }

  function compact(n) {
    if (n >= 1000000) {
      var m = Math.round(n / 100000) / 10;
      return (m % 1 === 0 ? m.toFixed(0) : m.toFixed(1)) + "M";
    }
    if (n >= 1000) {
      var k = n / 1000;
      if (k >= 100) return Math.round(k) + "K";
      var k1 = Math.round(k * 10) / 10;
      return (k1 % 1 === 0 ? k1.toFixed(0) : k1.toFixed(1)) + "K";
    }
    return String(n);
  }

  function full(n) {
    return n.toLocaleString("en-US");
  }

  function label(n, useFull) {
    return (useFull ? full(n) : compact(n)) + " views";
  }

  function paint(fromN) {
    document.querySelectorAll("[data-ads-views]").forEach(function (el) {
      var handle = el.getAttribute("data-ads-views");
      if (!handle) return;
      var useFull = el.hasAttribute("data-ads-views-full");
      var to = rawCount(handle);
      var start = typeof fromN === "number" ? fromN : to;
      if (useFull && start !== to) {
        tick(el, start, to);
      } else {
        el.textContent = label(to, useFull);
      }
    });
  }

  function tick(el, from, to) {
    el.classList.add("ads-views--tick");
    var start = performance.now();
    var dur = 420;
    function step(now) {
      var t = Math.min(1, (now - start) / dur);
      var eased = 1 - Math.pow(1 - t, 3);
      var n = Math.round(from + (to - from) * eased);
      el.textContent = label(n, true);
      if (t < 1) requestAnimationFrame(step);
      else el.classList.remove("ads-views--tick");
    }
    requestAnimationFrame(step);
  }

  function recordPlay(handle) {
    handle = normalize(handle);
    var sessionKey = "swx-ads-views-played:" + handle;
    try {
      if (sessionStorage.getItem(sessionKey)) return false;
      sessionStorage.setItem(sessionKey, "1");
    } catch (e) {
      if (window.__adsViewed) return false;
      window.__adsViewed = true;
    }
    var bag = extras();
    bag[handle] = (bag[handle] || 0) + 1;
    try {
      localStorage.setItem(EXTRA_KEY, JSON.stringify(bag));
    } catch (e2) {}
    return true;
  }

  function bindPlay(video, handle) {
    function tryCount() {
      if (!userArmed) return;
      var before = rawCount(handle);
      if (!recordPlay(handle)) return;
      paint(before);
    }
    video.addEventListener("play", tryCount);
    video.addEventListener("pointerdown", function () {
      userArmed = true;
      if (!video.paused) tryCount();
    });
  }

  function placeUnderVideos() {
    var handle = window.__adsHandle;
    if (!handle) return;
    var root = document.querySelector(".article-template__content");
    if (!root) return;
    root.querySelectorAll("video").forEach(function (video) {
      if (video.closest(".ads-views-stage")) return;
      var stage = document.createElement("div");
      stage.className = "ads-views-stage";
      video.parentNode.insertBefore(stage, video);
      stage.appendChild(video);
      var meta = document.createElement("p");
      meta.className = "ads-views ads-views--under";
      meta.setAttribute("data-ads-views", handle);
      meta.setAttribute("data-ads-views-full", "");
      stage.appendChild(meta);
      bindPlay(video, handle);
    });
  }

  function armUser(e) {
    var t = e.target;
    if (!t) return;
    if (t.closest && t.closest("video, .ads-views-stage")) userArmed = true;
  }

  function init() {
    document.addEventListener("pointerdown", armUser, true);
    placeUnderVideos();
    paint();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
  setInterval(function () {
    paint();
  }, 60000);
})();
